import "../styles.css";
import { useTranslation } from "react-i18next";
import TestWaitScreen from "../TestWaitScreen";

export default function MobileWaitingDesktop() {
  const { t } = useTranslation();

  return (
    <TestWaitScreen subhead={t("Waiting for action on desktop device...")} />
  );
}
